'use strict';

class SecureFileUploaderCompleteStageController {
  constructor($state, $rootScope, $scope, statusIndicatorService, intTypeValidationService) {
    this.name = 'secureFileUploaderCompleteStage';
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.statusIndicatorService = statusIndicatorService;
    this.typeValidationService = intTypeValidationService;
  }

  isUnManagedCustomer() {
    return this.typeValidationService.isUnManagedCustomer();
  }

  jumpToAssignAssignments() {
    this.$state.go('home.assign.productsSelector');
  }

  jumpToUploadHistory() {
    this.$rootScope.$emit('syncSettingsTabChanged','uploadHistory');
  }

  completedWithErrors() {
    return this.uploadState.completeWithErrors;
  }
}

SecureFileUploaderCompleteStageController.$inject = ['$state', '$rootScope', '$scope', 'statusIndicatorService', 'intTypeValidationService'];

export default SecureFileUploaderCompleteStageController;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderCompleteStage/secureFileUploaderCompleteStage.controller.js